import { useUserStore } from '@/shared/store/useUserStore';

export function profileStoreActiveCard() {
  const userStore = useUserStore();
  return userStore.hasActivePhysicalUserCard;
}
